<dx-data-grid id="purchasingUnitsGridContainer"
              [dataSource]="rows"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [showBorders]="true"
              [columnAutoWidth]="true"
              (onInitialized)="onGridInitialized($event)"
              (onContentReady)="onContentReady($event)">

  <dxo-editing mode="cell"
               [allowUpdating]="true"
               [allowAdding]="false"
               [allowDeleting]="false"
               [useIcons]="true"></dxo-editing>

  <dxo-group-panel [visible]="true"
                   emptyPanelText="{{ 'Spalten-Header hierher ziehen um zu gruppieren' | translate }}"></dxo-group-panel>
  <dxo-grouping [autoExpandAll]="true" expandMode="rowClick"></dxo-grouping>
  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-header-filter [visible]="true"></dxo-header-filter>
  <dxo-master-detail [enabled]="true" template="detailTemplate"></dxo-master-detail>

  <dxo-toolbar>
    <dxi-item name="groupPanel" location="before"></dxi-item>
    <dxi-item location="before" [visible]="hasActiveState">
      <div *dxTemplate>
        <span class="filter-reset-hint">
          {{ 'Bitte' | translate }}
          <a href="javascript:void(0)"
             class="dx-link"
             role="button"
             (click)="applyFilterReset()">{{ 'hier' | translate }}</a>
          {{ 'klicken um alle Filter zu löschen' | translate }}
        </span>
      </div>
    </dxi-item>
    <dxi-item location="after">
      <div *dxTemplate>
        <div class="d-flex flex-row align-items-center gap-2">
          <label class="mb-0">{{ 'Grundeinheit' | translate }}:</label>
          <np-dropdown-control class="base-unit-dropdown"
                               [items]="baseUnitItems"
                               [value]="getBaseUnit()"
                               (onCustomItemCreating)="onBaseUnitCustomItemCreating($event)"
                               (onValueChanged)="onBaseUnitChanged($event)"></np-dropdown-control>
        </div>
      </div>
    </dxi-item>
  </dxo-toolbar>

  <dxi-column dataField="unit" caption="{{ 'Einheit' | translate }}" [allowEditing]="false"></dxi-column>
  <dxi-column dataField="pid" caption="{{ 'Artikelnummer' | translate }}" [allowEditing]="false"></dxi-column>
  <dxi-column dataField="internationalId" caption="{{ 'International ID' | translate }}" [allowEditing]="false"></dxi-column>

  <dxi-column dataField="gevisMapping"
              caption="{{ 'Gevis Mapping' | translate }}"
              [visible]="isGevis()"
              [showInColumnChooser]="isGevis()"
              cellTemplate="gevisMappingTemplate"
              editCellTemplate="gevisMappingTemplate"></dxi-column>
  <div *dxTemplate="let cell of 'gevisMappingTemplate'">
    <div class="np-field w-100">
      <np-inputControl [(model)]="product"
                       [showLinkButtons]="false"
                       [showPlaceLabel]="cell?.data?.gevisMapping?.length > 0"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, cell?.data?.supplierOrder)"
                       labelText="{{ 'Gevis Mapping' | translate }}"
                       field="SUPPLIER_PURCHASING_GEVIS_MAPPING"
                       [system]="cell?.data?.supplierOrder"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">
        <div slot="content" class="contentSlot">
          <dx-text-box class="inDataGrid" [(value)]="cell.data.gevisMapping" [readOnly]="true"></dx-text-box>
        </div>
      </np-inputControl>
    </div>
  </div>

  <dxi-column dataField="contentQuantity"
              caption="{{ 'Menge Bestelleinheit' | translate }}"
              dataType="number"
              cellTemplate="contentQuantityTemplate"
              editCellTemplate="contentQuantityTemplate"></dxi-column>
  <div *dxTemplate="let cell of 'contentQuantityTemplate'">
    <div class="np-field w-100 d-flex flex-row align-items-center gap-2">
      <np-inputControl class="flex-fill"
                       [(model)]="product"
                       [showLinkButtons]="false"
                       [showPlaceLabel]="cell?.data?.contentQuantity != null"
                       [suppressLabel]="true"
                       [suppressToolTip]="true"
                       [(selectedElements)]="selectedElements"
                       (elementSelected)="templateSelect($event, cell?.data?.supplierOrder)"
                       (onValueChanged)="update($event, cell.data, 'SUPPLIER_PURCHASING_CONTENT_QUANTITY', cell?.data?.supplierOrder)"
                       labelText="{{ 'Menge Bestelleinheit' | translate }}"
                       field="SUPPLIER_PURCHASING_CONTENT_QUANTITY"
                       [system]="cell?.data?.supplierOrder"
                       [showDragHandle]="showDragHandle"
                       [dragFilter]="dragFilter"
                       (excelElementDropped)="excelElementDrop($event)">
        <div slot="content" class="contentSlot">
          <dx-number-box class="inDataGrid"
                         [(value)]="cell.data.contentQuantity"
                         [readOnly]="readOnly('SUPPLIER_PURCHASING_CONTENT_QUANTITY')"
                         [showClearButton]="showClearButton()"
                         (onValueChanged)="update($event, cell.data, 'SUPPLIER_PURCHASING_CONTENT_QUANTITY', cell?.data?.supplierOrder)"></dx-number-box>
        </div>
      </np-inputControl>
      <span class="text-nowrap">{{ getUnitDisplay(getBaseUnit()) }}</span>
    </div>
  </div>

  <dxi-column dataField="supplierId" caption="{{ 'Lieferant' | translate }}" [allowEditing]="false">
    <dxo-lookup [dataSource]="supplierNames" valueExpr="id" displayExpr="name"></dxo-lookup>
  </dxi-column>

  <div *dxTemplate="let detail of 'detailTemplate'">
    <div class="purchasing-detail d-flex flex-row flex-wrap gap-3">
      <div class="detail-field">
        <np-inputControl [(model)]="product" [showLinkButtons]="false" [suppressToolTip]="true"
                         [(selectedElements)]="selectedElements"
                         (elementSelected)="templateSelect($event, detail?.data?.supplierOrder)"
                         (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_WIDTH', detail?.data?.supplierOrder)"
                         labelText="{{ 'Breite (m)' | translate }}"
                         field="SUPPLIER_PURCHASING_WIDTH" [system]="detail?.data?.supplierOrder"
                         [showDragHandle]="showDragHandle" [dragFilter]="dragFilter"
                         (excelElementDropped)="excelElementDrop($event)">
          <div slot="content" class="contentSlot">
            <dx-number-box [(value)]="detail.data.width" [readOnly]="readOnly('SUPPLIER_PURCHASING_WIDTH')"
                           (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_WIDTH', detail?.data?.supplierOrder)"></dx-number-box>
          </div>
        </np-inputControl>
      </div>
      <div class="detail-field">
        <np-inputControl [(model)]="product" [showLinkButtons]="false" [suppressToolTip]="true"
                         [(selectedElements)]="selectedElements"
                         (elementSelected)="templateSelect($event, detail?.data?.supplierOrder)"
                         (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_LENGTH', detail?.data?.supplierOrder)"
                         labelText="{{ 'Länge (m)' | translate }}"
                         field="SUPPLIER_PURCHASING_LENGTH" [system]="detail?.data?.supplierOrder"
                         [showDragHandle]="showDragHandle" [dragFilter]="dragFilter"
                         (excelElementDropped)="excelElementDrop($event)">
          <div slot="content" class="contentSlot">
            <dx-number-box [(value)]="detail.data.length" [readOnly]="readOnly('SUPPLIER_PURCHASING_LENGTH')"
                           (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_LENGTH', detail?.data?.supplierOrder)"></dx-number-box>
          </div>
        </np-inputControl>
      </div>
      <div class="detail-field">
        <np-inputControl [(model)]="product" [showLinkButtons]="false" [suppressToolTip]="true"
                         [(selectedElements)]="selectedElements"
                         (elementSelected)="templateSelect($event, detail?.data?.supplierOrder)"
                         (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_DEPTH', detail?.data?.supplierOrder)"
                         labelText="{{ 'Tiefe (m)' | translate }}"
                         field="SUPPLIER_PURCHASING_DEPTH" [system]="detail?.data?.supplierOrder"
                         [showDragHandle]="showDragHandle" [dragFilter]="dragFilter"
                         (excelElementDropped)="excelElementDrop($event)">
          <div slot="content" class="contentSlot">
            <dx-number-box [(value)]="detail.data.depth" [readOnly]="readOnly('SUPPLIER_PURCHASING_DEPTH')"
                           (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_DEPTH', detail?.data?.supplierOrder)"></dx-number-box>
          </div>
        </np-inputControl>
      </div>
      <div class="detail-field">
        <np-inputControl [(model)]="product" [showLinkButtons]="false" [suppressToolTip]="true"
                         [(selectedElements)]="selectedElements"
                         (elementSelected)="templateSelect($event, detail?.data?.supplierOrder)"
                         (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_WEIGHT', detail?.data?.supplierOrder)"
                         labelText="{{ 'Gewicht (kg)' | translate }}"
                         field="SUPPLIER_PURCHASING_WEIGHT" [system]="detail?.data?.supplierOrder"
                         [showDragHandle]="showDragHandle" [dragFilter]="dragFilter"
                         (excelElementDropped)="excelElementDrop($event)">
          <div slot="content" class="contentSlot">
            <dx-number-box [(value)]="detail.data.weight" [readOnly]="readOnly('SUPPLIER_PURCHASING_WEIGHT')"
                           (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_WEIGHT', detail?.data?.supplierOrder)"></dx-number-box>
          </div>
        </np-inputControl>
      </div>
      <div class="detail-field">
        <np-inputControl [(model)]="product" [showLinkButtons]="false" [suppressToolTip]="true"
                         [(selectedElements)]="selectedElements"
                         (elementSelected)="templateSelect($event, detail?.data?.supplierOrder)"
                         (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_QUANTITY_MIN', detail?.data?.supplierOrder)"
                         labelText="{{ 'Mindestmenge' | translate }}"
                         field="SUPPLIER_PURCHASING_QUANTITY_MIN" [system]="detail?.data?.supplierOrder"
                         [showDragHandle]="showDragHandle" [dragFilter]="dragFilter"
                         (excelElementDropped)="excelElementDrop($event)">
          <div slot="content" class="contentSlot">
            <dx-number-box [(value)]="detail.data.quantityMin" [readOnly]="readOnly('SUPPLIER_PURCHASING_QUANTITY_MIN')"
                           (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_QUANTITY_MIN', detail?.data?.supplierOrder)"></dx-number-box>
          </div>
        </np-inputControl>
      </div>
      <div class="detail-field" *ngIf="isGevis()">
        <np-inputControl [(model)]="product" [showLinkButtons]="false" [suppressToolTip]="true"
                         [(selectedElements)]="selectedElements"
                         (elementSelected)="templateSelect($event, detail?.data?.supplierOrder)"
                         (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_QUANTITY_MAX', detail?.data?.supplierOrder)"
                         labelText="{{ 'Höchstmenge' | translate }}"
                         field="SUPPLIER_PURCHASING_QUANTITY_MAX" [system]="detail?.data?.supplierOrder"
                         [showDragHandle]="showDragHandle" [dragFilter]="dragFilter"
                         (excelElementDropped)="excelElementDrop($event)">
          <div slot="content" class="contentSlot">
            <dx-number-box [(value)]="detail.data.quantityMax" [readOnly]="readOnly('SUPPLIER_PURCHASING_QUANTITY_MAX')"
                           (onValueChanged)="update($event, detail.data, 'SUPPLIER_PURCHASING_QUANTITY_MAX', detail?.data?.supplierOrder)"></dx-number-box>
          </div>
        </np-inputControl>
      </div>
    </div>
  </div>

</dx-data-grid>
